import { render, staticRenderFns } from "./SubdivisionsTable.vue?vue&type=template&id=132a51dc&"
import script from "./SubdivisionsTable.vue?vue&type=script&lang=js&"
export * from "./SubdivisionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports